(function ($) {

    window.JdaUploadSettings = {
        dummyImageUrl: window.app.helpers.funcs.url('Resources/app/assets/img/ui/image-file-icon.png'),
        uploadTargetUrl: null,
        $dropAreaElem: null,
        documentIdsInputName: null,
        removeButtonText: "Remove",
        canShowRealThumbs: function () {
            return app.helpers.funcs.fileReaderSupported();
        },
        alwaysUseClientSideThumb: false,
        fileRemovedMessage: 'File successfully removed.',
        fileUploadedSuccessfullyMessage: 'File successfully uploaded.',
        fileUploadFailedMessage: 'File upload failed.',
        maxFileSizeBytes: 5242880, // 5MB. Blocks the upload attempt outright; the exact error shown comes from the per-form validation constraints (see profileConstraints.js / registerConstraints.js).
        fireScreenReaderOnly: function (message) {
            app.ui.uiPlugins.toast.fireScreenReaderOnly(message);
        }
    };

    var JdaUpload = function ($inputElem, options) {

        /*##################################################################
		// Init
		##################################################################*/

        /*================================================
        Vars passed in on instantiation
        ================================================*/

        this.$inputElem = $inputElem;

        // These are the defaults.
        this.settings = $.extend({}, window.JdaUploadSettings, options);

        /*================================================
        Vars set during runtime
        ================================================*/

        this.$documentIdsInput = null;
        this.files = [];

        /*================================================
        Other vars
        ================================================*/

        var scope = this;

        /*##################################################################
		// Methods
		##################################################################*/

        // Init
        // ----

        this.init = function () {
            scope.reader = scope.canShowRealThumbs() ? new FileReader() : null;
            scope.addEventListeners();
            scope.addMediatorListeners();
            var documentIdsInputName = scope.settings.documentIdsInputName || scope.$inputElem.attr('name') + '_documentIds';
            scope.$documentIdsInput = $('<input name="'+ documentIdsInputName +'" class="documentIdsInput" type="hidden" data-ignored="1" />');
            scope.$documentIdsInput.appendTo(scope.$inputElem.parent());
            
            // Initialize the IDs input with the images pre-loaded
            var $previews = this.$inputElem.closest('.file-feedback-group').find('.preview');
            $previews.each(function () {
                var idsValue = scope.$documentIdsInput.val();
                if (idsValue !== "") {
                    idsValue += ",";
                }
                idsValue += $(this).data("image-id");
                scope.$documentIdsInput.val(idsValue);
            });

            if ($previews.length > 0) {
                scope.settings.$dropAreaElem.find('.drop-placeholder-msg').hide();
                scope.settings.$dropAreaElem.addClass("has-files");
            } else {
                scope.settings.$dropAreaElem.addClass("no-files");
            }
        };

        this.addEventListeners = function ($elem, embedType) {

            scope.settings.$dropAreaElem.on('drag dragstart dragend dragover dragenter dragleave drop', function(e) {
                e.preventDefault();
                e.stopPropagation();
            });

            scope.$inputElem.change(function (e) {
                scope.fileInputOnChange(e);
            });

            scope.settings.$dropAreaElem.on('drop', function (e) {
                scope.dropAreaOnDrop(e);
            });

            scope.$inputElem.on(EVENT_NAME__JDA_UPLOAD__FILES_SET, function () {
                scope.adjustDropzoneClasses();
                scope.settings.fireScreenReaderOnly(scope.settings.fileUploadedSuccessfullyMessage);
            });

            scope.$inputElem.on(EVENT_NAME__JDA_UPLOAD__FILE_REMOVED, function () {
                scope.settings.fireScreenReaderOnly(scope.settings.fileRemovedMessage);
            });

            $('body').on('click', '.file-feedback-group .remove-btn', function() {
                var $previewElement = $(this).closest('.preview');
                scope.removeFile($previewElement);
            });
        };

        this.addMediatorListeners = function () {
            var scope = this;
            app.mediator.addListener(EVENT_NAME__PROFILE_FORM__IMAGE_DOESNT_EXIST,
                function (data) {
                    scope.removeUnavailableImage(data);
                });

            app.mediator.addListener(EVENT_NAME__REGISTER_FORM__IMAGE_DOESNT_EXIST,
                function (data) {
                    scope.removeUnavailableImage(data);
                });
        };

        this.removeUnavailableImage = function (data) {
            var scope = this;
            var $previewElement = $('.preview[data-image-id=' + data.documentId + ']');
            scope.removeFile($previewElement);
            var $previews = scope.$inputElem.closest('.file-feedback-group').find('.preview');
            if ($previews.length === 0) {
                scope.settings.$dropAreaElem.removeClass("has-files");
                scope.settings.$dropAreaElem.addClass("no-files");
                scope.$documentIdsInput.val('');
            }
        };

        this.removeFile = function ($elementToRemove) {
            var documentId = $elementToRemove.data('image-id');
            $($elementToRemove).parent().remove();
            var idsValue = scope.$documentIdsInput.val();
            idsValue = idsValue.replace(documentId, "");
            idsValue = idsValue.replace(",,", ",");
            if (idsValue === "") {
                scope.settings.$dropAreaElem.find('.drop-placeholder-msg').show();
                scope.settings.$dropAreaElem.addClass("no-files");
                scope.settings.$dropAreaElem.removeClass("has-files");
                scope.files = [];
            }

            scope.$documentIdsInput.val(idsValue);
            scope.$inputElem[0].value = "";
            scope.$inputElem.trigger(EVENT_NAME__JDA_UPLOAD__FILE_REMOVED);
            scope.updateImagePreviewHtmlToIndicateNotLoading();

            $inputElem.focus();
        };
        

        this.adjustDropzoneClasses = function () {
            if (typeof this.settings.$dropAreaElem !== 'null') {
                if (this.files.length) {
                    this.settings.$dropAreaElem.removeClass('no-files');
                    this.settings.$dropAreaElem.addClass('has-files');
                } else {
                    this.settings.$dropAreaElem.removeClass('has-files');
                    this.settings.$dropAreaElem.addClass('no-files');
                }
            }
        }

        this.fileInputOnChange = function (e) {
            var files = e.target.files;
            var eType = 'standard';
            scope.handleFilesEvent(e, eType, files);
        };

        this.dropAreaOnDrop = function (e) {
            var files = e.originalEvent.dataTransfer.files;
            scope.handleFilesEvent(e, 'drop', files);
        };

        this.handleFilesEvent = function (e, eType, files) {
            scope.files = files;

            if (scope.hasOversizedFile(files)) {
                // Don't attempt the upload at all - just surface the existing per-form validation
                // message (e.g. the maxFileSize constraint) immediately, against the files as selected.
                scope.$inputElem.trigger(EVENT_NAME__JDA_UPLOAD__FILE_TOO_LARGE, {
                    files: files,
                    evtType: eType,
                    evt: e
                });
                return;
            }

            scope.updateImagePreviewHtmlToIndicateLoading();
            scope.uploadFilesWithAjax(files, function (documents) {
                var guids = "";
                for (var i = 0; i < documents.length; i++) {
                    if (guids !== "") {
                        guids += ",";
                    }
                    guids += documents[i].id;
                }
                scope.$documentIdsInput.val(guids);
                scope.documents = documents;

                scope.clearImagePreviewHtml();
                for (var i = 0; i < scope.documents.length; i++) {
                    var document = scope.documents[i];
                    var file = scope.files[i];
                    scope.appendImagePreviewHtml(file, document);
                }
                scope.updateImagePreviewHtmlToIndicateNotLoading();
                scope.$inputElem.trigger(EVENT_NAME__JDA_UPLOAD__FILES_SET, {
                    files: files,
                    evtType: eType,
                    evt: e
                });
            }, function () {
                scope.updateImagePreviewHtmlToIndicateNotLoading();
                scope.showUploadFailedMessage();
            });
        };

        this.hasOversizedFile = function (files) {
            for (var i = 0; i < files.length; i++) {
                if (files[i].size > scope.settings.maxFileSizeBytes) {
                    return true;
                }
            }
            return false;
        };

        this.showUploadFailedMessage = function () {
            app.ui.uiPlugins.toast.fire(scope.settings.fileUploadFailedMessage, 'danger');
        };

        this.uploadFilesWithAjax = function (files, callback, errorCallback) {

            var scope = this;

            var collectedDocuments = [];
            var hasFailed = false;
            for (var i = 0; i < files.length; i++) {
                collectedDocuments.push(null);
            }
            for (var i = 0; i < files.length; i++) {
                (function (j) {
                    scope.uploadFileWithAjax(files[j], function (guid, url) {
                        if (hasFailed) return;
                        collectedDocuments[j] = { id: guid, url: url };
                        tryCallback();
                    }, function () {
                        if (hasFailed) return;
                        hasFailed = true;
                        if (typeof errorCallback == 'function') {
                            errorCallback.call(null);
                        }
                    });
                })(i);
            }

            var tryCallback = function() {
                var allOk = true;
                collectedDocuments.forEach(function (document) {
                    if (!document) allOk = false;
                });
                if (allOk) {
                    if (typeof callback == 'function') {
                        callback.call(null, collectedDocuments);
                    }
                }
            };
        }

        this.uploadFileWithAjax = function (file, callback, errorCallback) {
            var formData = new FormData();
            formData.append('file', file);
            if (this.settings.uploadTargetUrl) {
                $.ajax({
                    type: "POST",
                    url: this.settings.uploadTargetUrl,
                    data: formData,
                    cache: false,
                    contentType: false,
                    processData: false,
                    dataType: "json",
                    success: function(response) {
                        if (response && response.success && response.result) {
                            if (typeof callback == 'function') {
                                callback.call(null, response.result.id, response.result.url);
                            }
                        } else {
                            if (typeof errorCallback == 'function') {
                                errorCallback.call(null);
                            }
                        }
                    },
                    error: function () {
                        if (typeof errorCallback == 'function') {
                            errorCallback.call(null);
                        }
                    }
                });
            }
        };

        // Test
        // ----

        this.canShowRealThumbs = function () {
            return scope.settings.canShowRealThumbs();
        };

        // Get
        // ----

        this.getFormElem = function () {
            return scope.$dropAreaElem.closest('form');
        };

        this.getFiles = function () {
            return scope.files;
        };

        this.updateImagePreviewHtmlToIndicateLoading = function () {
            scope.settings.$dropAreaElem.find('.drop-placeholder-msg').append(app.helpers.funcs.getSpinnerHtml());
        };

        this.updateImagePreviewHtmlToIndicateNotLoading = function () {
            scope.settings.$dropAreaElem.find('.drop-placeholder-msg .spinner-wrap').remove();
        };

        this.clearImagePreviewHtml = function () {
            scope.settings.$dropAreaElem.find('.drop-placeholder-msg').hide();
            scope.settings.$dropAreaElem.find('.wrap-previews').html([
                '<div class="row">',
                '</div>'
            ].join(''));
        };

        this.appendImagePreviewHtml = function (file, document) {
            var scope = this;
            if (file.type.match('image.*') && scope.canShowRealThumbs()) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    var url = scope.settings.alwaysUseClientSideThumb ? e.target.result : document.url;
                    var previewHtml = scope.getPreviewHtml(document.id, url, file.name);
                    scope.settings.$dropAreaElem.find('.wrap-previews').append(previewHtml);
                };
                reader.readAsDataURL(file);
            } else {
                var dummyImageUrl = scope.settings.dummyImageUrl;
                var previewHtml = scope.getPreviewHtml(document.id, dummyImageUrl, file.name);
                scope.settings.$dropAreaElem.find('.wrap-previews').append(previewHtml);
            }
        };

        this.getPreviewHtml = function (id, imgUrl, filename) {
            return [
                '<div class="col-xs-12 col-sm-4 col-md-3">',
                    '<div class="preview" data-image-id="' + id + '">',
                        '<img id="preview-image" class="preview-image" src="' + imgUrl + '" alt="' + filename + '" />',
                        '<span class="filename-caption" title="' + filename + '">' + filename + '</span>',
                         '<button class="btn btn-inverse btn-block btn-sm remove-btn" id="removeFileButton" data-validation-name="removeFileButton" aria-label="'+scope.settings.removeButtonText +': ' + filename + '">',
                            '<span class="btn-inner">' + scope.settings.removeButtonText + '</span>',
                         '</button>',
                    '</div>',
                '</div>'
            ].join('');
        };

        // Set / call
        // ----

        // tbc

        /*##################################################################
		// Chaining / init
		##################################################################*/

        // this.init();
        return this;
    }

    $.fn.jdaUpload = function (options) {
        var instances = [];
        this.each(function () {
            var instance = $(this).data('jdaUpload');
            if ((!instance) && options !== true) {
                // If options are true we are only checking to see if jdaValidate exists on the supplied element
                var $el = $(this);
                var idInputNameFromData = $(this).data('id-input-name');
                if (idInputNameFromData && typeof options.documentIdsInputName === 'undefined') {
                    options.documentIdsInputName = idInputNameFromData
                }
                var instance = new JdaUpload($(this), options);
                $el.data('jdaUpload', instance);
                instance.init();
            }
            instances.push(instance);
        });
        return instances.length > 1 ? instances : instances[0];
    };

}(jQuery));